// extracted by mini-css-extract-plugin
export var container = "_7d-0";
export var icon = "_7d-1";
export var text = "_7d-2";